import { Component } from '@angular/core';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { Router, NavigationStart } from '@angular/router';
import { ComponentService } from './main/content/services/component.service';
import { AppService } from './main/content/services/app.service';


@Component({
    selector: 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    constructor(
        private fuseSplashScreen: FuseSplashScreenService,
        private router: Router,
        private configService: ComponentService,
        public appService: AppService
    ) {
        router.events
            .filter(event => event instanceof NavigationStart)
            .subscribe((event: NavigationStart) => {
                let pageName = event.url;
                
                pageName = pageName.replace('/','');
                if(pageName != "login"){
                    this.appService.checkSession();
                }
                if(pageName == "fshipper"){
                    pageName = 'finance'
                }
                sessionStorage.setItem('pageName', pageName);
                this.configService.get(pageName).subscribe(
                    res => this.getTranslationSuccessCallback(res),
                    error => this.apiFailure(error)
                );
            });
    }

    getTranslationSuccessCallback(res) {
        if (res["Data"] != "null") {
            sessionStorage.setItem('pageData', res["Data"]);
        }

    }
    apiFailure(error): void {
        sessionStorage.setItem('pageData', "");
    }
}



// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/app.component.ts